// extracted by mini-css-extract-plugin
module.exports = {"svg":"style_svg__wI9Ke","needsAttentionPulse":"style_needsAttentionPulse__Ap3gc"};